module.exports = __webpack_public_path__ + "static/media/fvs_fremdlinge_63.52c2689a.jpg";